// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"49de86a7","330":"39a7e5d9","337":"e10e216f","361":"13890f63","428":"9fcf2786","453":"43397eec","455":"e8ca7a4b","467":"65c72b6e","473":"f090fcf5","480":"10c6827e","516":"49e52246","637":"97f9980e","800":"dab1f2d3"}[chunkId] + ".chunk.js";
};